import React, { useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TestOption from "../compnents/TestOption";
import FileUploader from "@jumbo/Dashboards/Media/FileUploader";
import TestTitle from "../compnents/TestTitle";
import ImagePicker from "../compnents/ImagePicker";
import SortingContainer from "../compnents/SortingContainer";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    marginTop: 10,
  },
  answerSelectText: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
}));

const FileUploadQuestionElement = ({
  questoinTitle,
  setQuestoinTitle,
  cover,
  setCover,
  score,
  setScore,
  files,
  setFiles,
}) => {
  const classes = useStyles();
  const [openFileUploader, setOpenFileUploader] = useState(false);

  return (
    <React.Fragment>
      <TestTitle
        value={questoinTitle}
        handeChange={(value) => setQuestoinTitle(value)}
      />
      <Grid item xs={12}>
        <Typography className={classes.answerSelectText}>
          انتخاب تصویر سوال
        </Typography>
        <ImagePicker
          cover={cover}
          handlePick={() => setOpenFileUploader(true)}
          handleRevome={() => setCover("")}
          previewStyles={{ marginInline: "auto", marginBlock: "20px" }}
          placeHolderStyles={{ marginInline: "auto", marginBlock: "20px" }}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.answerSelectText}>
          وارد کردن نام فایل ها
        </Typography>
        <SortingContainer items={files} setItems={setFiles} />
      </Grid>

      <TestOption
        text={""}
        title={"پله"}
        type={"number"}
        value={score}
        handleChange={(value) => setScore(+value)}
      />
      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={(selected) => setCover(selected)}
        selectedItem={cover}
        imageSelector={true}
      />
    </React.Fragment>
  );
};

export default FileUploadQuestionElement;
